import React from 'react';
import Languages from './Languages/Languages';
import ProfileMenu from './ProfileMenu/ProfileMenu';
import Notifications from './Notifications/Notifications';
import { useDispatch, useSelector } from 'react-redux';

const RightToolBar = () => {
    const dispatch = useDispatch();
    const failedTasks = useSelector(state => state.utilities.failedTasks);
    const pendingTasks = useSelector(state => state.utilities.pendingTasks);


    return (<ul className="nav navbar-toolbar navbar-right navbar-toolbar-right">
        <span
            className="nav-link"
            title="tasks"
            aria-expanded="false"
            style={{ cursor: 'pointer' }}
            onClick={() => dispatch({ type: "OPEN_BACKGROUND_TASK_MODAL" })}>
            <i className={`fa fa-hourglass-${pendingTasks ? pendingTasks > 0 ? 'half' : failedTasks ? failedTasks > 0 ? 'end' : 'o' : 'o' : 'o'}`} style={{ fontSize: '12px'}} aria-hidden="true"></i>
            <span className={`badge badge-pill badge-${pendingTasks > 0 ? 'primary' : failedTasks > 0 ? 'danger' : 'secondary'} up`}>{pendingTasks ? pendingTasks > 0 ? pendingTasks : failedTasks ? failedTasks > 0 ? failedTasks : 0 : 0 : 0}</span>

        </span>

        <Notifications />
        <Languages />
        <ProfileMenu />
    </ul >
    )
};

export default RightToolBar;